import { Link } from "react-router-dom";
import { FooterSection } from "../../landing-page/sections/FooterSection";
import { Header } from "../../landing-page/sections/headerSection";
import "./PrivacyPolicyPage.scss";

const privacySections = [
  {
    title: "Responsable du traitement",
    content: [
      "Le responsable du traitement des données personnelles est l'Agence des Systèmes d'Information et du Numérique (ASIN), représentée par son Directeur Général.",
      "Les demandes relatives aux données personnelles peuvent être adressées au Délégué à la Protection des Données à l'adresse protectiondesdonnees@asin.bj ou au contact institutionnel contact@asin.bj.",
    ],
  },
  {
    title: "Données collectées",
    content: [
      "La plateforme peut traiter les informations d'identification des utilisateurs, leurs coordonnées, leurs habilitations, les données de connexion, les traces d'opérations, les données de référentiels et les documents transmis dans le cadre des services.",
      "Selon les fonctionnalités utilisées, les données peuvent inclure des informations professionnelles, administratives ou techniques nécessaires à la création des comptes, à la gestion des accès, au support et à l'interopérabilité entre systèmes publics.",
    ],
  },
  {
    title: "Finalités du traitement",
    content: [
      "Les données sont traitées pour administrer les comptes, gérer les accès, assurer le support, sécuriser la plateforme, tracer les opérations, maintenir les référentiels et faciliter la coordination inter-administrative.",
      "Elles peuvent également être utilisées pour respecter les obligations légales, répondre aux demandes des structures publiques concernées et produire les éléments nécessaires au contrôle ou à l'audit des services.",
    ],
  },
  {
    title: "Destinataires",
    content: [
      "Les données sont accessibles aux services habilités de l'ASIN et, lorsque cela est nécessaire, aux structures publiques concernées par le service ou le référentiel traité.",
      "Elles peuvent être communiquées aux autorités compétentes lorsqu'une obligation légale, réglementaire ou judiciaire l'exige.",
      "L'ASIN ne vend pas, ne loue pas et ne rend pas commercialement accessibles les données personnelles traitées par la plateforme.",
    ],
  },
  {
    title: "Sécurité et confidentialité",
    content: [
      "L'ASIN met en oeuvre des mesures techniques et organisationnelles destinées à protéger les données contre la perte, la destruction, l'altération, l'accès non autorisé ou tout traitement non conforme.",
      "Les traces d'opérations sont utilisées pour des raisons de sécurité, d'audit et de continuité du service.",
      "Les données ne sont pas utilisées à des fins de profilage commercial ni soumises à des décisions automatisées produisant des effets juridiques pour les utilisateurs.",
    ],
  },
  {
    title: "Durée de conservation",
    content: [
      "Les données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées.",
      "Certaines données peuvent être conservées plus longtemps lorsque la loi l'exige, lorsqu'elles sont nécessaires à la preuve, à la sécurité, à l'archivage ou à la continuité des services publics.",
    ],
  },
  {
    title: "Droits des personnes concernées",
    content: [
      "Conformément au Code du numérique en République du Bénin, les personnes concernées peuvent exercer leurs droits d'accès, d'interrogation, de rectification, de mise à jour, d'opposition, de suppression, d'oubli ou de réparation selon le traitement concerné.",
      "La demande doit préciser les données concernées et permettre l'identification du demandeur. Elle peut être transmise par courrier électronique à protectiondesdonnees@asin.bj ou contact@asin.bj.",
      "L'ASIN répond aux demandes dans les délais prévus par la réglementation applicable.",
    ],
  },
  {
    title: "Réclamation auprès de l'APDP",
    content: [
      "Si une personne estime que ses droits ne sont pas respectés, elle peut adresser une réclamation à l'Autorité de Protection des Données Personnelles (APDP).",
      "Contact APDP: contact@apdp.bj.",
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main className="PrivacyPolicyPage">
        <section className="PrivacyPolicyPage-hero">
          <Link className="PrivacyPolicyPage-backLink" to="/">
            Retour à l'accueil
          </Link>
          <p className="PrivacyPolicyPage-eyebrow">Données personnelles</p>
          <h1 className="PrivacyPolicyPage-title">Politique de confidentialité</h1>
          <p className="PrivacyPolicyPage-intro">
            Cette politique explique comment la Plateforme Nationale d'Interopérabilité collecte,
            utilise, protège et conserve les données personnelles nécessaires à la gestion des
            référentiels de l'administration béninoise.
          </p>
        </section>

        <section className="PrivacyPolicyPage-content" aria-label="Politique de confidentialité">
          {privacySections.map((section) => (
            <article className="PrivacyPolicyPage-section" key={section.title}>
              <h2 className="PrivacyPolicyPage-sectionTitle">{section.title}</h2>
              {section.content.map((paragraph) => (
                <p className="PrivacyPolicyPage-paragraph" key={paragraph}>
                  {paragraph}
                </p>
              ))}
            </article>
          ))}
        </section>
      </main>
      <FooterSection />
    </>
  );
}
